import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { IMPORT_EXPORT_TAB } from '../../constant'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/macroeconomics/importExport/importExportTable',
  initialState: {
    tab: IMPORT_EXPORT_TAB.GROWTH_RATE_PERCENT.key,
  },
  reducers: {
    changeTab: (state, action) => {
      state.tab = action.payload
    },
  },
})

register(slice.name, slice.reducer)

export const selectMacroImportExportTable = (state) => state[slice.name]
export const selectTab = (state) => state[slice.name].tab

export const { changeTab } = slice.actions
